import { NotifyPropertyChangedBase } from "../../../utilities/reflection";
import { AdornerService } from "../../../services/basics/adorner-service";
import { autoinject, transient } from "aurelia-dependency-injection";
import { ViewResources, View, BindingEngine, Disposable } from "aurelia-framework";

@autoinject
@transient()
export class Adorner {

    private _subscriptions: { model: AdornerModel, subscription: Disposable }[] = [];

    models: AdornerModel[] = [];


    constructor(adornerService: AdornerService, private bindingEngine: BindingEngine) {

        adornerService.onAdd((model) => {
            if (model.context && model.element && model.html) {
                this.models.push(model);
                this._subscriptions.push({
                    model: model,
                    subscription: this.bindingEngine.propertyObserver(model.context, 'isDropdownOpen').subscribe(() => {
                        if (model.context.isDropdownOpen) {
                            model.setStyleString();
                        }
                    })
                });
            }
        });

        adornerService.onRemove((model) => {
            const index = this.models.indexOf(model);
            if (index >= 0) {
                this.models.splice(index, 1);

                const subIndex = this._subscriptions.findIndex(x => x.model == model);
                this._subscriptions.splice(subIndex, 1);
            }
        });

        setInterval(() => {
            for (const item of this.models.filter(x => x.context.isDropdownOpen)) {
                item.setStyleString();
            }
        }, 120);
    }
}

export class AdornerModel extends NotifyPropertyChangedBase {
    element: any;
    html: string | View;
    autoWidth: boolean;
    adornerDirection: string;
    context: any;
    reference: any;
    oldStyles: string;
    resourcesExisting: ViewResources;
    styleString: string;

    constructor(context: any, html: string | View, element: any, autoWidth: boolean, adornerDirection: string, resourcesExisting: ViewResources) {
        super();
        this.context = context;
        this.html = html;
        this.element = element;
        this.autoWidth = autoWidth;
        this.adornerDirection = adornerDirection;
        this.resourcesExisting = resourcesExisting;
    }

    setStyleString(): void {
        //left: ${model.left}px; top: ${model.top}px; width: ${model.width};

        let styleTop = 0;
        let styleLeft = 0;
        let styleWidth = '';

        const boundingClientRect = this.element ? this.element.getBoundingClientRect() : null;
        const dropdownEl = $(this.reference).find('.main-slot-child').children().get(0);
        const elementTop = $(this.element).offset().top;
        const dropdownHeight = $(dropdownEl).outerHeight();
        const dropdownBottom = this.reference ? (elementTop + dropdownHeight) : 0;
        const top = this.element ? elementTop : 0;
        if (this.adornerDirection == "auto") {
            if (this.reference && dropdownBottom > $(".app-body").height()) {
                styleTop = (top - dropdownHeight) - $(this.element).parent().outerHeight();
            } else {
                styleTop = top;
            }
        } else if (this.adornerDirection == "up") {
            styleTop = (top - $(this.reference).outerHeight()) - $(this.element).parent().outerHeight();
        } else {
            styleTop = top;
        }

        styleLeft = boundingClientRect ? boundingClientRect.left : 0;
        styleWidth = boundingClientRect && !this.autoWidth ? (boundingClientRect.width + 'px') : 'auto';

        this.styleString = `left: ${styleLeft}px; top: ${styleTop}px; width: ${styleWidth};`;
    }
}
